import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=01becc10&scoped=true&lang=pug&"
import script from "./AppBar.vue?vue&type=script&lang=js&"
export * from "./AppBar.vue?vue&type=script&lang=js&"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=01becc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01becc10",
  null
  
)

export default component.exports